export const ERROR_CODE = {
  INTERNAL_SERVER_ERROR: 500,
  UNAUTHENTICATED: 401,
  GATEWAY: 502,
  TIMEOUT: 504,
  ERR_CLIENT: 400,
  SUCCESS: 200,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
};
